"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var nextUniqueId = 0;
function getNextUniqueId() {
    return nextUniqueId++;
}
exports.default = getNextUniqueId;



//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/lib/cjs/utils/getNextUniqueId.js
// module id = 788
// module chunks = 4